import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
const isUnknownField = formField => formField.objectTypeId === FormFieldPropertyObjectTypesIds.UNKNOWN;
export default isUnknownField;